/**
 * Product Badges - Auto-limit based on grid column count
 * 
 * Sets data-limit on each card's badge list based on number of columns in grid:
 * - Mobile:
 *   - 1 col → 2 badges
 *   - 2 col → 2 badges
 * - Desktop:
 *   - 3 col → 3 badges
 *   - 4 col → 3 badges
 *   - 6 col → 2 badges
 */

(() => {
  const MAP = (cols) => {
    if (cols === 1) return 2; // Mobile: 2 badges
    if (cols === 2) return 2;
    if (cols === 3) return 3;
    if (cols === 4) return 3;
    if (cols >= 6) return 2;
    return 2; // default (safer fallback)
  };

  const getCols = (gridEl) => {
    // Calculate actual columns from computed style
    const style = window.getComputedStyle(gridEl);
    const template = style.getPropertyValue('grid-template-columns');
    if (!template) return null;
    const cols = template.split(' ').length;
    return cols || null;
  };

  const applyLimits = () => {
    // Target ProductGridContainer and other collection grids
    const grids = document.querySelectorAll(
      '#ProductGridContainer .product-grid, #product-grid, .collection .grid, [id^="ProductGrid"]'
    );
    
    grids.forEach((grid) => {
      const cols = getCols(grid) || 4;
      const limit = MAP(cols);
      const lists = grid.querySelectorAll('.product-badges__list[data-context="collection"]');
      
      lists.forEach((list) => {
        list.setAttribute('data-limit', String(limit));
      });
    });
  };

  // Use ResizeObserver for dynamic updates
  const ro = new ResizeObserver(() => applyLimits());

  const init = () => {
    applyLimits();
    
    // Observe grids for responsive changes
    const grids = document.querySelectorAll(
      '#ProductGridContainer .product-grid, #product-grid, .collection .grid, [id^="ProductGrid"]'
    );
    grids.forEach((g) => ro.observe(g));

    // Safety net: update on resize
    window.addEventListener('resize', applyLimits, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

